// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseStepPhase } from './ResponseStepPhase';
import {
  ResponseStepPhaseFromJSON,
  ResponseStepPhaseFromJSONTyped,
  ResponseStepPhaseToJSON,
  ResponseStepPhaseToJSONTyped,
} from './ResponseStepPhase';
import type { ResponseResourceProgress } from './ResponseResourceProgress';
import {
  ResponseResourceProgressFromJSON,
  ResponseResourceProgressFromJSONTyped,
  ResponseResourceProgressToJSON,
  ResponseResourceProgressToJSONTyped,
} from './ResponseResourceProgress';

/**
 *
 * @export
 * @interface ResponseCompletionStepDetail
 */
export interface ResponseCompletionStepDetail {
  /**
   * ActiveClusterRolloutCount is the number of cluster copies that have
   * finished every configured step and not yet completed this one.
   * @type {number}
   * @memberof ResponseCompletionStepDetail
   */
  activeClusterRolloutCount?: number;
  /**
   *
   * @type {string}
   * @memberof ResponseCompletionStepDetail
   */
  completedAt?: string;
  /**
   * CompletedClusterRolloutCount is the number of cluster copies that have
   * completed this step.
   * @type {number}
   * @memberof ResponseCompletionStepDetail
   */
  completedClusterRolloutCount?: number;
  /**
   *
   * @type {string}
   * @memberof ResponseCompletionStepDetail
   */
  name?: string;
  /**
   * Phase is the least-advanced phase of this step across cluster copies.
   * @type {ResponseStepPhase}
   * @memberof ResponseCompletionStepDetail
   */
  phase?: ResponseStepPhase;
  /**
   *
   * @type {Array<ResponseResourceProgress>}
   * @memberof ResponseCompletionStepDetail
   */
  resourceProgresses?: Array<ResponseResourceProgress>;
  /**
   *
   * @type {string}
   * @memberof ResponseCompletionStepDetail
   */
  startedAt?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseCompletionStepDetail
   */
  transferFinishedAt?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseCompletionStepDetail
   */
  transferStartedAt?: string;
}

/**
 * Check if a given object implements the ResponseCompletionStepDetail interface.
 */
export function instanceOfResponseCompletionStepDetail(
  value: object,
): value is ResponseCompletionStepDetail {
  return true;
}

export function ResponseCompletionStepDetailFromJSON(
  json: any,
): ResponseCompletionStepDetail {
  return ResponseCompletionStepDetailFromJSONTyped(json, false);
}

export function ResponseCompletionStepDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseCompletionStepDetail {
  if (json == null) {
    return json;
  }
  return {
    activeClusterRolloutCount:
      json['activeClusterRolloutCount'] == null
        ? undefined
        : json['activeClusterRolloutCount'],
    completedAt: json['completedAt'] == null ? undefined : json['completedAt'],
    completedClusterRolloutCount:
      json['completedClusterRolloutCount'] == null
        ? undefined
        : json['completedClusterRolloutCount'],
    name: json['name'] == null ? undefined : json['name'],
    phase:
      json['phase'] == null
        ? undefined
        : ResponseStepPhaseFromJSON(json['phase']),
    resourceProgresses:
      json['resourceProgresses'] == null
        ? undefined
        : (json['resourceProgresses'] as Array<any>).map(
            ResponseResourceProgressFromJSON,
          ),
    startedAt: json['startedAt'] == null ? undefined : json['startedAt'],
    transferFinishedAt:
      json['transferFinishedAt'] == null
        ? undefined
        : json['transferFinishedAt'],
    transferStartedAt:
      json['transferStartedAt'] == null ? undefined : json['transferStartedAt'],
  };
}

export function ResponseCompletionStepDetailToJSON(
  json: any,
): ResponseCompletionStepDetail {
  return ResponseCompletionStepDetailToJSONTyped(json, false);
}

export function ResponseCompletionStepDetailToJSONTyped(
  value?: ResponseCompletionStepDetail | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    activeClusterRolloutCount: value['activeClusterRolloutCount'],
    completedAt: value['completedAt'],
    completedClusterRolloutCount: value['completedClusterRolloutCount'],
    name: value['name'],
    phase: ResponseStepPhaseToJSON(value['phase']),
    resourceProgresses:
      value['resourceProgresses'] == null
        ? undefined
        : (value['resourceProgresses'] as Array<any>).map(
            ResponseResourceProgressToJSON,
          ),
    startedAt: value['startedAt'],
    transferFinishedAt: value['transferFinishedAt'],
    transferStartedAt: value['transferStartedAt'],
  };
}
